<template>
  <b-button
    variant="link"
    :disabled="disabled"
    class="cust-button"
    :style="custStyle"
    @click="onClick"
    >{{ text }}</b-button
  >
</template>

<script>
import Vue from 'vue';
import { BButton } from 'bootstrap-vue';
Vue.component('b-button', BButton);

export default {
  name: 'PureButton',
  props: {
    text: {
      type: String,
      default: '',
    },
    colorType: {
      type: String,
      default: 'dark',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    custStyle: {
      type: Object,
      default: () => {},
    },
  },
  computed: {},
  methods: {
    // emit event
    onClick() {
      this.$emit('onClick');
    },
  },
};
</script>

<style scoped>
.cust-button {
  height: 36px;
  border-radius: 4px;
  text-decoration: none;
  color: #ffffff;
  background-color: #b18147;
  margin: 10px;
}
</style>
